<div class="modal-header">
    <span class="pull-right">
        <button class="btn btn-default btn-xs" (click)="close()"><i class="glyphicon glyphicon-remove"></i></button>
    </span>
    <span>
        <h4 class="modal-title">{{ request.title }}</h4>
    </span>  
</div>
  
<div class="modal-body" [formGroup]="createExperimentForm">
    <div class="form-horizontal">   
        <div class="form-group" [class.has-error]="facility.invalid">
            <label class="control-label col-sm-4">Facility</label>
            <div class="col-sm-8">
                <select class="form-control" formControlName="facility">
                    <option [ngValue]="null"></option>
                    <option *ngFor="let facility of facilities" [value]="facility.id">
                        {{ facility.name }}
                    </option>
                </select>
            </div>
        </div>

        <div class="form-group" [class.has-error]="prismExperimentName.invalid">
            <label class="control-label col-sm-4">PRISM Experiment Name</label>
            <div class="col-sm-8">
                <input type="text" class="form-control" [readOnly]="true" formControlName="prismExperimentName"/>
            </div>
        </div>

        <div *ngIf="planningNotes.specificAoiRequired">
            <div class="form-group">
                <label class="control-label col-sm-4">Specific AOI Required</label>
                <div class="col-sm-8 form-control-static">{{ plannedAOILocation }}</div>
            </div>            
        </div>       
        
        <div class="form-group" [class.has-error]="aoi.invalid">
            <label class="control-label col-sm-4">AOI</label>
            <div class="col-sm-8">
                <select class="form-control" formControlName="aoi">
                    <option [ngValue]="null"></option>
                    <option *ngFor="let aoi of aois" [ngValue]="aoi">
                        {{ aoi.name }}
                    </option>
                </select>
            </div>
        </div>      

        <div class="form-group" [class.has-error]="actualPlantDate.invalid">
            <label class="control-label col-sm-4">Actual Plant Date</label>
            <app-ce-date-picker
                formControlName="actualPlantDate"
                [minDate]="minPlantDate"
                placement="right">
            </app-ce-date-picker>
        </div>
        <div class="alert alert-danger col-sm-offset-4" 
            *ngIf="!actualPlantDate.pristine && actualPlantDate.errors?.min">
            Actual Plant Date must be today or later
        </div>
    </div>
</div>

<div class="modal-footer">
<button class="btn btn-primary" (click)="createExperiment()" [disabled]="createExperimentForm.invalid">Create Experiment</button>
</div>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/create-experiment-modal/create-experiment-modal.component.html